export default {
  computed: {
    fields() {
      return [
        {
          key: 'number',
          label: 'Kode',
          thAttr: {
            style: 'min-width:80px;',
          },
        },
        {
          key: 'vehicle.license_plate',
          label: 'Plat Nomor',
          thAttr: {
            style: 'min-width:200px;',
          },
        },
      ]
    }
  }
}